import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=39df119f&scoped=true&"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNotes.vue?vue&type=style&index=0&id=39df119f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39df119f",
  null
  
)

export default component.exports